import {
  closeWebviewInJD,
  jumpToJDIndexWebview,
  goBackInJD,
  disablePageBouncesInJD,
  getAppVersionInJD,
} from '@/utils/jsBridge/jd/jsBridge'

import {
  closeWebviewInJDJR,
  jumpToJDJRIndexWebview,
  goBackInJDJR,
  getAppVersionInJDJR,
} from '@/utils/jsBridge/jdjr/jsBridge'

// import { reportSGM } from '@/utils/sgm'
import { interceptorfy } from '@/utils/interceptorfy'
// import { ESGMLogType } from '@/config/sgm'

// function handleUnexceptedCall(methodName: string) {
//   reportSGM({
//     code: `JSBridge_${methodName}`,
//     ext: { type: ESGMLogType.JSBridgeError },
//     desc: `JSBridge_${methodName} was called not in JD or JDJR`,
//   })
// }

/**
 * @description 调用关闭Webview方法
 */
const closeWebview = interceptorfy(() => {
  handleUnexceptedCall('closeWebview')
})
closeWebview.useFns([closeWebviewInJDJR, closeWebviewInJD])

/**
 * @description 调用跳转App首页方法
 */
const jumpToIndexWebview = interceptorfy(() => {
  handleUnexceptedCall('jumpToIndex')
})
jumpToIndexWebview.useFns([jumpToJDJRIndexWebview, jumpToJDIndexWebview])

/**
 * @description 回退至上一级页面（若没有上一级页面则关闭当前页面）
 */
const goBackRouter = interceptorfy(() => {
  handleUnexceptedCall('closeWebview')
})
goBackRouter.useFns([goBackInJD, goBackInJDJR])

/**
 * @description 禁用iOS页面回弹
 */
const disableAppPageBounces = interceptorfy(() => {})
disableAppPageBounces.useFns([disablePageBouncesInJD])

/**
 * @description 获取App版本号
 */
const getAppVersionInfo = interceptorfy(() => {
  return ''
})

getAppVersionInfo.useFns([getAppVersionInJD, getAppVersionInJDJR])

export {
  closeWebview,
  jumpToIndexWebview,
  goBackRouter,
  disableAppPageBounces,
  getAppVersionInfo,
}